import { useEffect } from 'react';
import './LegalPages.css';

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <title>Refund Policy - Pidesk</title>
      <meta name="description" content="Pidesk's refund policy for digital website services and products" />

      <div className="legal-page">
        <div className="container">
          <div className="legal-content">
            <h1>Refund Policy</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section>
              <h2>Overview</h2>
              <p>
                At Pidesk, we are committed to providing exceptional digital website services and solutions to organizations and individuals. 
                This refund policy outlines the terms under which refunds may be issued for our services and products.
              </p>
            </section>

            <section>
              <h2>Digital Services Refund Policy</h2>
              <h3>Website Development Services</h3>
              <ul>
                <li>Due to the custom nature of website development, deposits and payments made for ongoing projects are non-refundable once work has commenced.</li>
                <li>If you are not satisfied with the initial design concepts, we offer one major revision cycle at no additional cost.</li>
                <li>Refunds may be considered only if we fail to deliver the agreed-upon features within the specified timeline, subject to project complexity.</li>
              </ul>

              <h3>Digital Products</h3>
              <ul>
                <li>Digital products, including templates, themes, and downloadable resources, are non-refundable once downloaded.</li>
                <li>We offer a 7-day refund window for digital products if they are defective or not as described.</li>
                <li>To request a refund for digital products, contact us within 7 days of purchase with proof of defect.</li>
              </ul>
            </section>

            <section>
              <h2>Subscription Services</h2>
              <ul>
                <li>Monthly and annual subscription plans are billed in advance and are non-refundable.</li>
                <li>You may cancel your subscription at any time to avoid future charges.</li>
                <li>Cancelled subscriptions will remain active until the end of the current billing period.</li>
                <li>No partial refunds are provided for unused portions of a subscription period.</li>
              </ul>
            </section>

            <section>
              <h2>Refund Process</h2>
              <h3>How to Request a Refund</h3>
              <ol>
                <li>Contact our support team at support@pidesk.com within the eligible refund period.</li>
                <li>Provide your order number, purchase date, and detailed reason for the refund request.</li>
                <li>Include any relevant documentation or evidence to support your claim.</li>
                <li>Our team will review your request within 5-7 business days.</li>
              </ol>

              <h3>Refund Timeline</h3>
              <ul>
                <li>Approved refunds will be processed within 7-10 business days.</li>
                <li>Refunds will be issued to the original payment method used for the purchase.</li>
                <li>Bank processing times may vary and are beyond our control.</li>
              </ul>
            </section>

            <section>
              <h2>Non-Refundable Items</h2>
              <ul>
                <li>Custom development work beyond the initial design phase</li>
                <li>Domain name registrations and renewals</li>
                <li>Third-party services and integrations</li>
                <li>Setup and installation fees</li>
                <li>Services already rendered or completed</li>
                <li>Training and consultation services</li>
              </ul>
            </section>

            <section>
              <h2>Force Majeure</h2>
              <p>
                We shall not be liable for any failure or delay in providing services due to circumstances beyond our reasonable control, 
                including but not limited to acts of God, natural disasters, war, terrorism, or government actions.
              </p>
            </section>

            <section>
              <h2>Contact Information</h2>
              <p>
                For questions about our refund policy or to request a refund, please contact us:
              </p>
              <ul>
                <li>Email: support@pidesk.com</li>
                <li>Phone: +1 (555) 123-4567</li>
                <li>Address: 123 Business Ave, Suite 100, City, State 12345</li>
              </ul>
            </section>

            <section>
              <h2>Policy Changes</h2>
              <p>
                We reserve the right to modify this refund policy at any time. Changes will be effective immediately upon posting 
                on our website. Your continued use of our services constitutes acceptance of any changes.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
